import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
const UpdateModal = ({ toggleModal, kel, kelas }) => {
  const [waktuMulai, waktuSelesai] = kelas.jam.split(" - ");

  const { control, register } = useForm({
    defaultValues: {
      kelompok: {
        value: kel,
        label: kel,
      },
      tipe: {
        value: kelas.tipe,
        label: kelas.tipe,
      },
      topik: {
        value: kelas.topik,
        label: kelas.topik,
      },
      tanggal: "2024-10-21",
      waktuMulai: waktuMulai,
      waktuSelesai: waktuSelesai,
      ruangan: {
        value: kelas.ruangan,
        label: kelas.ruangan,
      },
      pengajar: {
        value: kelas.pengajar,
        label: kelas.pengajar,
      },
      status: {
        value: kelas.status,
        label:
          kelas.status === 0
            ? "ON SCHEDULE"
            : kelas.status === 1
            ? "ON GOING"
            : kelas.status === 2
            ? "FINISHED"
            : "CANCELED",
      },
    },
  });

  const kelompokOption = [
    { value: "A", label: "A" },
    { value: "B", label: "B" },
  ];

  const tipeOption = [
    { value: 1, label: "TUTORIAL" },
    { value: 2, label: "PLENO" },
    { value: 3, label: "KKD" },
    { value: 4, label: "PERKULIAHAN" },
    { value: 5, label: "PRAKTIKUM" },
  ];

  const topikOption = [
    { value: 1, label: "Pendahuluan" },
    { value: 2, label: "Sirkulasi Jantung" },
  ];

  const ruanganOption = [
    { value: 1, label: "501" },
    { value: 2, label: "502" },
    { value: 3, label: "503" },
  ];

  const fasilitatorOption = [
    { value: "Purnamawati Tjhin", label: "Purnamawati Tjhin" },
    { value: "Eveline Margo", label: "Eveline Margo" },
    { value: "Tjam Diana Samara", label: "Tjam Diana Samara" },
  ];

  const statusOption = [
    { value: 0, label: "ON SCHEDULE" },
    { value: 1, label: "ON GOING" },
    { value: 2, label: "FINISHED" },
    { value: 3, label: "CANCELED" },
  ];
  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Pertemuan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Kelompok</label>
          <Controller
            control={control}
            name="kelompok"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={kelompokOption}
                {...field}
              />
            )}
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Tipe Pertemuan</label>
          <Controller
            control={control}
            name="tipe"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={tipeOption}
                {...field}
              />
            )}
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Topik</label>
          <Controller
            control={control}
            name="topik"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={topikOption}
                {...field}
              />
            )}
          />
          <Link style={{ textDecoration: "none" }}>+ Tambah Topik Baru</Link>
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Tanggal</label>
          <input
            type="date"
            {...register("tanggal")}
            className="form-control"
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Waktu Mulai</label>
          <input
            type="time"
            {...register("waktuMulai")}
            className="form-control"
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Waktu Selesai</label>
          <input
            type="time"
            {...register("waktuSelesai")}
            className="form-control"
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Ruangan</label>
          <Controller
            control={control}
            name="ruangan"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={ruanganOption}
                {...field}
              />
            )}
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Pengajar</label>
          <Controller
            control={control}
            name="pengajar"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={fasilitatorOption}
                {...field}
              />
            )}
          />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Status</label>
          <Controller
            control={control}
            name="status"
            render={({ field }) => (
              <Select
                placeholder="-- Pilih Salah Satu --"
                value={field.value}
                options={statusOption}
                {...field}
              />
            )}
          />
        </div>

        <button className="btn w-100 btn-success" onClick={closeModal}>
          Ubah
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateModal;
